import searchReducer from './reducers';

export { default as searchTypes } from './types';

export default searchReducer;
